import { connect } from "react-redux";
import LeadApproval from "./leadApproval";
import { bindActionCreators } from "redux";
import { getLeadApprovalList, acceptLeadApproval, rejectLeadApproval } from "services/redux/approvals/salesApprovals/action"
import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  approvalList: state.salesApprovalReducer.leadApprovalList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getLeadApprovalList,
    acceptLeadApproval,
    rejectLeadApproval,
    fetchZones,
  getListFilterData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LeadApproval);
